import produce from 'immer';
import {FacetFiltersState} from './facet-filter-type';
import {getRetainFilterAcrossSearches, setRetainFilterAcrossSearches} from './facet-filter-locastorage';
import {FacetFilterChangedAction} from './facet-filter-actions';

const initialState: FacetFiltersState = {
    retainFilterAcrossSearches: getRetainFilterAcrossSearches(),
};

export function facetFilterReducer(state: FacetFiltersState = initialState, action: FacetFilterChangedAction): FacetFiltersState {
    return produce(state, (draft: FacetFiltersState) => {
        switch (action.type) {
            case 'RETAIN_FILTER_CHANGED': {
                draft.retainFilterAcrossSearches = action.retainFilterAcrossSearches;
                setRetainFilterAcrossSearches(action.retainFilterAcrossSearches);
                break;
            }
        }
    });
}
